import styled from 'styled-components'
import { ContainerSombra } from '../../../../components/ContainerSombra'

export const titulosGeradosStyles = {
  CardCabecalho: styled(ContainerSombra)`
    margin-bottom: 19px;
    padding: 9px;
  `,
  ContainerBranco: styled(ContainerSombra)`
    margin-top: 29px;
    padding: 0 8px;
  `
}
